import React from "react";
import { styled } from "@mui/system";
import PropTypes from "prop-types";
import { POSITION_ABSOLUTE, POSITION_RELATIVE } from "../config/styles";
import {
  PoweredByLogo,
  RAKGroupLogo,
  SkiplyPurpleLogo,
} from "../assets/icons/index.js";

const GroupLogoStyled = styled("div")(() => ({
  position: POSITION_RELATIVE,
  width: "137px",
  height: "65px",
  top: "2px",
  "& .powered-by": {
    position: POSITION_ABSOLUTE,
    width: "51px",
    height: "9px",
    top: "56px",
    left: "0px",
  },
  "& .word-group": {
    position: POSITION_ABSOLUTE,
    width: "56px",
    height: "7px",
    top: "56px",
    left: "54px",
  },
}));

export const GroupLogo = ({ bgColor }) => {
  return (
    <GroupLogoStyled>
      <div className="powered-by">
        <PoweredByLogo />
      </div>
      <div className="word-group">
        <RAKGroupLogo />
      </div>
      <SkiplyPurpleLogo bgColor={bgColor} />
    </GroupLogoStyled>
  );
};

GroupLogo.propTypes = {
  bgColor: PropTypes.string,
};
